var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import axios from 'axios';
import Bowser from 'bowser';
import { debounce } from 'lodash';
import { format, parse } from 'date-fns';
/** Number of consecutive API failures before we stop sending requests entirely. Resets to 0 on any success. */
var CIRCUIT_BREAKER_THRESHOLD = 5;
/** How long (ms) to stay stopped after hitting the failure threshold. After this cooldown, the next call retries. */
var CIRCUIT_BREAKER_COOLDOWN_MS = 60000;
/** Wait time (ms) before firing a request. Rapid calls with the same event name within this window collapse into one. */
var DEBOUNCE_MS = 300;
var circuitBreaker = {
    consecutiveFailures: 0,
    openUntil: 0,
};
var isCircuitOpen = function () {
    if (circuitBreaker.consecutiveFailures < CIRCUIT_BREAKER_THRESHOLD) {
        return false;
    }
    if (Date.now() >= circuitBreaker.openUntil) {
        circuitBreaker.consecutiveFailures = 0;
        return false;
    }
    return true;
};
var recordSuccess = function () {
    circuitBreaker.consecutiveFailures = 0;
};
var recordFailure = function () {
    circuitBreaker.consecutiveFailures += 1;
    if (circuitBreaker.consecutiveFailures >= CIRCUIT_BREAKER_THRESHOLD) {
        circuitBreaker.openUntil = Date.now() + CIRCUIT_BREAKER_COOLDOWN_MS;
    }
};
var debouncedPosters = new Map();
/** Parses a Retry-After header value into milliseconds. Supports delta-seconds (e.g. "120") and HTTP-date formats. */
var parseRetryAfter = function (header) {
    if (!header)
        return null;
    var seconds = Number(header);
    if (!Number.isNaN(seconds) && seconds > 0) {
        return seconds * 1000;
    }
    var dateMs = Date.parse(header);
    if (!Number.isNaN(dateMs)) {
        var delta = dateMs - Date.now();
        return delta > 0 ? delta : null;
    }
    return null;
};
var postEvent = function (payload, andThen) { return __awaiter(void 0, void 0, void 0, function () {
    var error_1, retryMs;
    var _j, _k;
    return __generator(this, function (_q) {
        switch (_q.label) {
            case 0:
                if (isCircuitOpen()) {
                    if (typeof andThen === 'function')
                        andThen();
                    return [2 /*return*/];
                }
                _q.label = 1;
            case 1:
                _q.trys.push([1, 3, 4, 5]);
                return [4 /*yield*/, axios.post(route('api.event'), payload)];
            case 2:
                _q.sent();
                recordSuccess();
                return [3 /*break*/, 5];
            case 3:
                error_1 = _q.sent();
                if (axios.isAxiosError(error_1) && ((_j = error_1.response) === null || _j === void 0 ? void 0 : _j.status) === 429) {
                    retryMs = parseRetryAfter((_k = error_1.response.headers) === null || _k === void 0 ? void 0 : _k['retry-after']);
                    circuitBreaker.consecutiveFailures = CIRCUIT_BREAKER_THRESHOLD;
                    circuitBreaker.openUntil = Date.now() + (retryMs !== null && retryMs !== void 0 ? retryMs : CIRCUIT_BREAKER_COOLDOWN_MS);
                }
                else {
                    recordFailure();
                }
                return [3 /*break*/, 5];
            case 4:
                if (typeof andThen === 'function')
                    andThen();
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); };
var getOrCreateDebouncedPoster = function (eventKey) {
    var poster = debouncedPosters.get(eventKey);
    if (!poster) {
        poster = debounce(function (payload, andThen) {
            postEvent(payload, andThen);
        }, DEBOUNCE_MS);
        debouncedPosters.set(eventKey, poster);
    }
    return poster;
};
var trackEvent = function (event_1) {
    var args_1 = [];
    for (var _j = 1; _j < arguments.length; _j++) {
        args_1[_j - 1] = arguments[_j];
    }
    return __awaiter(void 0, __spreadArray([event_1], args_1, true), void 0, function (event, properties, andThen) {
        var browser, loginMethod, payload, debouncedPoster;
        if (properties === void 0) { properties = {}; }
        if (andThen === void 0) { andThen = null; }
        return __generator(this, function (_k) {
            if (isCircuitOpen()) {
                if (typeof andThen === 'function')
                    andThen();
                return [2 /*return*/];
            }
            browser = Bowser.getParser(window.navigator.userAgent);
            loginMethod = getLoginMethod();
            payload = __assign({ event: event, browser: browser.getBrowser(), login_method: loginMethod, res: {
                    width: Math.max(document.body.scrollWidth, document.documentElement.scrollWidth, document.body.offsetWidth, document.documentElement.offsetWidth, document.documentElement.clientWidth),
                    height: Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.documentElement.clientHeight),
                } }, properties);
            debouncedPoster = getOrCreateDebouncedPoster(event);
            debouncedPoster(payload, andThen);
            return [2 /*return*/];
        });
    });
};
/**
 * Determines the login method (Desktop, Mobile, or Unknown) based on the user agent.
 */
var getLoginMethod = function () {
    var browser = Bowser.getParser(window.navigator.userAgent);
    var platform = browser.getPlatform();
    if (platform && platform.type) {
        if (platform.type === 'desktop') {
            return 'Desktop';
        }
        else if (platform.type === 'tablet' || platform.type === 'mobile') {
            return 'Mobile';
        }
        return platform.type;
    }
    return 'Unknown';
};
var formatDate = function (dateString) {
    if (!dateString) {
        return '';
    }
    for (var _j = 0, _k = ['MM/dd/yyyy', 'MM-dd-yyyy']; _j < _k.length; _j++) {
        var dtFormat = _k[_j];
        try {
            var parsed = parse(dateString, dtFormat, new Date());
            if (parsed instanceof Date) {
                return format(parsed, 'MM/dd/yyyy');
            }
        }
        catch (error) { }
    }
    throw new Error('No matching dtFormat for ' + dateString);
};
/**
 * Formats a date
 * @param {Date|string|null} date - The date to format
 * @returns {string} - Formatted date string or 'null' if no date provided
 */
var formatScheduledDateForTracking = function (date) {
    if (!date)
        return 'null';
    var dateObj = date instanceof Date ? date : new Date(date);
    return dateObj.toLocaleString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    });
};
export { circuitBreaker, CIRCUIT_BREAKER_COOLDOWN_MS, CIRCUIT_BREAKER_THRESHOLD, DEBOUNCE_MS, debouncedPosters, formatDate, formatScheduledDateForTracking, isCircuitOpen, parseRetryAfter, postEvent, recordFailure, recordSuccess, trackEvent, };
